import { useEffect, useState } from "react";

import useAxios from "@src/utility/hooks/use-axios";
import { useParams } from "react-router-dom";

const  useNotes = () => {
    const { clientId, platformId } = useParams();
    const [data, setData] = useState({
        notes     : [],
        pagination: {},
        macros    : {}
    });

    const [modalConfig, setModalConfig] = useState({
        isOpen: false,
        row   : {}
    });

    const { axiosInstance, loading, cancelAllRequests } = useAxios({ base: "panel", initialLoader: true });

    const handleModal = (row = {}) => {
        setModalConfig((prev) => ({
            isOpen: !prev.isOpen,
            row
        }));
    };
    const fetchMacros = async () => {
        const { data } =    await axiosInstance.get(`/notes/${platformId}/macros`);
        setData((prev) => ({
            ...prev,
            macros: data
        }));
    };

    const getAllNotes = async ({ page, limit }) => {
        const { data, pagination } = await axiosInstance.get(`/notes/${platformId}`, {
            params: {
                page,
                limit,
                clientId
            }
        });
        fetchMacros();
        setData((prev) => ({
            ...prev,
            notes: data,
            pagination
        }));
    };

    const handlePagination = ({ page = 1, limit = 10 }) => {
        getAllNotes({ page, limit });
    };
    
    const handleRowActions = async (row = {}, action = "") => {
        if (action === "delete") {
            await axiosInstance.delete(`/notes/${platformId}/${row.id}`);
            getAllNotes({ page: 1, limit: 10 });
        } else {
            handleModal(row);
        }
    };
    
    useEffect(() => {
        let isActive = true;
        if (isActive) {
            getAllNotes({ page: 1, limit: 10 });
        }
        return () => {
            cancelAllRequests();
            isActive = false;
        };
    }, []);

    return {
        loading,
        getAllNotes,
        handleRowActions,
        data,
        handleModal,
        modalConfig,
        handlePagination
    };
};

export default useNotes;